module.exports = __webpack_public_path__ + "media/file_icons/jpg-f0c66e7c.svg";